import React from "react";
import { Loader2 } from "lucide-react";

export const COVERS = [
  "https://images.unsplash.com/photo-1694532573669-f611b17fe414?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1634146330658-b052db81cd15?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1639350730745-5838cf34dadd?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1745402150365-2fa7a7ef5aab?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
];

export function coverFor(song) {
  if (song?.cover_url) return song.cover_url;
  let h = 0;
  const s = song?.id || song?.title || "x";
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return COVERS[h % COVERS.length];
}

export function fmtTime(sec) {
  if (!sec || isNaN(sec)) return "0:00";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function Waveform({ bars = 5, active = true, className = "" }) {
  return (
    <div className={`flex items-end gap-[2px] h-4 ${className}`} aria-hidden>
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="wave-bar"
          style={{
            height: active ? undefined : "30%",
            animationDelay: `${i * 0.12}s`,
            animationPlayState: active ? "running" : "paused",
          }}
        />
      ))}
    </div>
  );
}

export function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin ${className}`} />;
}

export function Money({ value }) {
  return <span>${Number(value || 0).toFixed(2)}</span>;
}
